<template>
  <div class="yearluck-base">
    <div class="head-image">
      <img src="/static/img/yearluck/y2020/maintitle.svg" />
      <p>大好評！今シーズンも、1年間の運勢が届きました。<br>
        読みやすくてボリュームたっぷり！<br>
        それぞれテキストで読むタイプと、<br>
        音声で聞くタイプが選べます。<br>
        豪華な監修陣が、テーマごとにしっかり占いました。<br>
        あなたの2020年、どんな年でしょう？<br>
        さっそく占ってみてね！</p>
    </div>
    <div class="fortune-type-base">
      <div class="fortune-type-card">
        <h3>占う項目は全部で12項目</h3>
        <p>総合／どんなことが起こる？／恋愛／結婚／家族／仕事／お金／人間関係／運気の流れ／上半期の月ごとのアドバイス／幸運日カレンダー／相性</p>
      </div>
    </div>

    <div class="counselors-base">
      <h3>監修者紹介</h3>
      <div class="counselor-list">
        <template v-for="(item, index) in counselorListMod">
          <counselor
            :c-name="item.name"
            :c-prof="item.profile"
            :c-image-url="item.image_url"
          ></counselor>
        </template>
      </div>
    </div>

    <div class="profile-form">
      <h3><img src="/static/img/yearluck/y2020/base_input_title.svg" /></h3>
      <form action="/2020_luck/summary" method="post">
        <input type="hidden" name="_token" :value="csrfToken" />
        <form-target-birthday
          name="birthday"
          type="tel"
          :value="myBirthdayMod"
          :label="''"
          :placeholder-year="'2000'"
          :placeholder-month="'01'"
          :placeholder-day="'01'"
          db-value
          @change="onTargetDateChange"
          :validation="{ rules: {
              required: true,
              regex: /[12][0-9]{3}([1][0-2]|[0][1-9])(0[1-9]|[12][0-9]|3[01])/,
              birthRange: true,
              max: 8,
              min: 8,
              } }"
        ></form-target-birthday>
        <input
          type="text"
          name="nickname"
          placeholder="ニックネーム"
          v-model="nicknameValue"
          @change="onNicknameChange"
          @keyup="onNicknameChange"
        />
      </form>
      <div class="submit-base">
        <span class="submit-btn" @click="onSubmit" :class="{disable: isSubmitDisable}">占う</span>
      </div>
    </div>
  </div>
</template>

<script>
import FormTargetBirthday from "@/utvStore/components/YearLuck/y2020/partials/FormTargetBirthday";
import Counselor from "@/utvStore/components/YearLuck/y2020/partials/counselor";
export default {
  name: "Yearluck2020Top",
  components: {Counselor, FormTargetBirthday },
  data() {
    return {
      isSubmitDisable: false,
      tgtBirthCheck: false,
      tgtNicknameCheck: false,
      nicknameValue: '',
      lock: false
    }
  },
  props: {
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
    counselorList: {
      type: Array,
      default() {
        return []
      }
    },
    myNickname: {
      type: String,
      default() {
        return ''
      }
    },
    myBirthday: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    myBirthdayMod() {
      let bd = this.myBirthday
      let y, m, d
      if(/^\d{4}-\d{2}-\d{2}$/.test(bd)) {
        [ y, m, d ] = bd.split('-').map(item => parseInt(item))
        this.tgtBirthCheck = true
      } else if(/^\d{8}$/.test(bd)) { //そのまま返してもいいけど一旦分ける
        y = parseInt(bd.substr(0,4))
        m = parseInt(bd.substr(4,2))
        d = parseInt(bd.substr(6,2))
        this.tgtBirthCheck = true
      }
      if(this.$el != null) {
        this.checkCanSubmit()
      }
      return [y, ('0' + m).slice(-2), ('0' + d).slice(-2)].join('')
    },
    counselorListMod() {
      return this.counselorList
    }
  },
  mounted() {
    if(this.myNickname != null && this.myNickname.length > 0){
      this.nicknameValue = this.myNickname
    }
    setTimeout(() => this.checkCanSubmit(),100)
  },
  methods: {
    onTargetDateChange(birth, err) {
      // console.log('BirthCheck: birth->%s err:%O', birth, err)
      this.tgtBirthCheck = !err
      this.checkCanSubmit()
    },
    onNicknameChange() {
      const nn = this.$el.querySelector('input[name=nickname]')
      this.checkCanSubmit()
    },
    checkCanSubmit() {
      if(this.$el != null && typeof this.$el.querySelector !== undefined) {
        const nn = this.$el.querySelector('input[name=nickname]')
        this.tgtNicknameCheck = /^.{1,8}$/.test(nn.value)
        // console.log('nickname:%s birth:%s', this.tgtNicknameCheck, this.tgtBirthCheck)

        if (this.tgtBirthCheck && this.tgtNicknameCheck) {
          this.isSubmitDisable = false
        } else {
          this.isSubmitDisable = true
        }
      }
    },
    onSubmit() {
      if(!this.lock) {
        this.lock = true
        this.checkCanSubmit()
        if(!this.isSubmitDisable){
          this.isSubmitDisable = true
          this.$el.querySelector('form').submit()
        } else {
          this.lock = false
        }
      }
    }
  }
}</script>
<style scoped lang="scss">
@import '../../../../../sass/variables/index';
.yearluck-base {
  color: $gray-20;
  .head-image {
    width: 100%;
    text-align: center;
    background: url('/static/img/yearluck/y2020/maintitle_bg.png') repeat center center;
    background-size: 250px;
    padding: 30px 0;
    font-weight: bold;
    font-size: 12px;
    line-height: 21px;
    margin-bottom: 40px;
  }
  .fortune-type-base {
    width: 100%;
    margin-bottom: 40px;

    .fortune-type-card {
      width: 298px;
      margin: auto;
      border: 2px solid $brown-10;
      font-size: 12px;
      line-height: 18px;
      position: relative;
      padding: 16px 22px 20px;
      @include mq('w320') {
        width: 325px;
      }
      @include mq() {
        width: 360px;
      }
      h3 {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
      }
      &:after {
        content: '';
        width: 4px;
        height: 100%;
        position: absolute;
        background: $brown-10;
        top: 3px;
        right: -5px;
      }
      &:before {
        content: '';
        width: 100%;
        height: 4px;
        position: absolute;
        background: $brown-10;
        bottom: -5px;
        left: 5px;
      }
    }
  }
  .counselors-base {
    width: 100%;
    padding: 20px 0;
    position: relative;
    margin-bottom: 40px;

    h3 {
      width: 100%;
      color: $brown-10;
      text-align: center;
      margin: 0 0 16px;
    }
    .counselor-list {
      display: flex;
      flex-wrap: wrap;
      padding-left: 24px;
      @include mq('w320') {
        padding-left: 8px;
      }
    }
    &::before {
      content: '';
      width: calc(100% - 16px - 16px);
      height: 1px;
      background: $gray-17;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
    &::after {
      content: '';
      width: calc(100% - 16px - 16px);
      height: 1px;
      background: $gray-17;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
  .profile-form {
    width: 100%;
    padding: 0 25px 32px;
    h3 {
      width: 100%;
      text-align: center;
    }
    .formGroup {
      margin-bottom: 10px;
    }
    /deep/ .calenderForm {
      width: 100%;
      justify-content: center;
      input {
        flex-basis: 50px;
      }
    }
    input[name='nickname'] {
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.15);
      text-align: center;
      font-size: 18px;
      padding: 12px;
      margin-bottom: 20px;
    }


    .submit-base {
      width: 100%;
      .submit-btn {
        width: 100%;
        background: $brown-10;
        color: white;
        display: block;
        padding: 12px 8px;
        position: relative;
        background: $brown-10;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        text-decoration: none;
        cursor: pointer;
        &:after {
          content: '';
          width: 10px;
          height: 18px;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 16px;
          margin: auto;
          background: url('/static/img/yearluck/y2020/next_white.svg') no-repeat center center;
          background-size: auto 18px;
          &.disable {
            background: $gray-21;
            pointer-events: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/yearluck2020Top.vue